module.exports = __webpack_public_path__ + "static/media/success.b0a20c39.png";